module.exports = __webpack_public_path__ + "static/img/quanmin_qmwallet2.8b54311d.png";